import * as actionTypes from "./constant";

const initialState = {
    assignFailedData:[]
}

export default function CustomerBulkAssignReducer(state = initialState, action){
    switch (action.type) {
        case actionTypes.ASSIGN_BULK_CUTOMER_SUCCESS_ACTION:
          
          return {
            ...state,
            assignFailedData: action.payload.assignStatus,
          };
        case actionTypes.CLEAR_BULK_ASSIGN_REPORT_INIT_ACTION:
          return {
            ...state,
            assignFailedData: action.payload
          }
        
   default :
   return {
    ...state,
  };
}
}